module.exports = __webpack_public_path__ + "static/media/prison-break-player-login-bg.bc874ecb.jpg";